import { render } from "./ChevronArrowRightIcon.vue?vue&type=template&id=2bc9b9dc"
const script = {}

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__